import { createTheme } from '@mui/material/styles';

// Brand palette — keep this as the single source of truth for the colors used
// across MUI components. The legacy custom.css still hardcodes #99C20E for
// non-MUI elements; new components should rely on color="primary"/"secondary".
const BRAND_GREEN = '#99C20E';
const BRAND_GREEN_HOVER = '#88ad0d';
const SLATE = '#4D5061';
const SLATE_HOVER = '#65687c';

export const correctTrackTheme = createTheme({
    palette: {
        primary: {
            main: BRAND_GREEN,
            dark: BRAND_GREEN_HOVER,
            contrastText: '#ffffff',
        },
        secondary: {
            main: SLATE,
            dark: SLATE_HOVER,
            contrastText: '#ffffff',
        },
        background: {
            default: '#fafafa',
        },
    },
    shape: {
        borderRadius: 6,
    },
    components: {
        MuiButton: {
            defaultProps: {
                disableElevation: true,
            },
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
        MuiDataGrid: {
            styleOverrides: {
                // The MUI X license watermark carries zIndex 100000. Isolating the grid keeps that
                // z-index local, so the notice stays on the grid instead of covering dialogs,
                // menus and the app bar.
                root: {
                    isolation: 'isolate',
                },
            },
        },
    },
});
